import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../../../button';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import ApiDatabase from 'server';

const ModalMissionSuspend = () => {
  const { toggle } = useModal();
  const { objID, setModalDataReturn, updateMissionStatusLocal } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [missionData, setMissionData] = useState(null);
  useEffect(() => {
    if (objID) {
      ApiDatabase.getMissionDetailsById(
        { idMission: objID },
        (data) => setMissionData(data),
        (err) => console.error(err),
        { skipCache: true }
      );
    }
  }, [objID]);

  const handleSubmit = () => {
    if (!objID) return;
    setIsLoading(true);
    ApiDatabase.updateMissionStatus(
      { idMission: objID, newStatus: 'suspended' },
      () => {
        updateMissionStatusLocal(objID, { status: 'suspended' });
        setModalDataReturn('mission_status_updated');
        toast.success('Le recrutement de la mission a été suspendu');
        setIsLoading(false);
        toggle();
      },
      (err) => {
        toast.error("Erreur lors de la suspension : " + err);
        setIsLoading(false);
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Suspendre le recrutement
      </Modalheader>
      <ModalBody>
        {!missionData ? (
          <div className="flex flex-col gap-3 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            <p>
              Êtes-vous sûr de vouloir suspendre le recrutement pour la
              mission{' '}
              <span className="font-black">
                {missionData.title} n°{missionData.id_mission}
              </span>
              . La mission ne sera plus visible par les candidats.
            </p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="LG" color="DISABLED">
            Confirmation ...
          </Button>
        ) : (
          <Button size="LG" color="PRIMARY" onClick={handleSubmit} disabled={!missionData}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalMissionSuspend;
